import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter, Redirect, Link } from 'react-router-dom'
import { FormattedMessage, FormattedHTMLMessage, injectIntl, intlShape } from 'react-intl';

import { recoverSession } from '../actions'
import { isAuthenticated, canRecover } from '../services/sessionService'
import { callApi } from '../services/fetchService'

import FaIcon from '../components/FaIcon'
import { Layout, Form, Input, Button, Spin, message } from 'antd';
const FormItem = Form.Item;
const { Content, Footer } = Layout;



/**
 * Login view
 */

class PasswordRecovery extends Component {

	static propTypes = {
        session: PropTypes.object,
        recoverSession: PropTypes.func.isRequired,
        location: PropTypes.object.isRequired,
        intl: intlShape.isRequired
    }

    state = {
        loading: false
    }

    componentWillMount() {
        const { session } = this.props

        if (!isAuthenticated(session)) {
            if (canRecover(session)) {
                if (!session.isRecovering) {
                    this.props.recoverSession()
                    return;
                }
            }
        }
    }
    
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({ loading: true })
                const { intl } = this.props
                callApi({
                    endpoint: 'recovery',
                    method: 'POST',
                    body: values
                }).then((data) => {
                    message.success(intl.formatMessage({id: 'passwordRecovery.recoveryEmailSent'}))
                    this.setState({ loading: false })
                }).catch((data) => {
                    if (data.status === 429) {
                        message.warn(intl.formatMessage({id: 'misc.tooManyRequests'}))
                    } else {
                        message.error(intl.formatMessage({id: 'misc.unknownError'}))
                    }
                    this.setState({ loading: false })
                })
            }
        })
    }
    
    render() {
        const { getFieldDecorator } = this.props.form;
        const { session, location, intl } = this.props;
        const { loading } = this.state;

        if (session.isRecovering && !loading) {
            return (<Layout style={{ background: '#fff', marginTop: '75px' }}><Spin size="large" /></Layout>)
        }
        if (session.user) {
            if (location.state && location.state.from) {
                return (<Redirect to={location.state.from} />)
            }
            return (<Redirect to={{ pathname: "/" }} />)
        }

        return (
            <Layout style={{ minHeight: '100vh', background: '#fff' }}>
                <Content style={{ margin: '16px' }}>
                    <Form onSubmit={this.handleSubmit} className="login-form">
                        <h1><FormattedMessage id="passwordRecovery.title" /></h1>
                        <FormattedHTMLMessage id="passwordRecovery.description" />
                        <FormItem>
                            {getFieldDecorator('email', {
                                rules: [
                                    { type: 'email', message: intl.formatMessage({id: 'passwordRecovery.wrongEmail'}) },
                                    { required: true, message: intl.formatMessage({id: 'passwordRecovery.emailRequired'}) }
                                ]
                            })(<Input prefix={<FaIcon icon="envelope" />} placeholder="E-mail" />)}
                        </FormItem>
                        <FormItem>
                            <Button type="primary" htmlType="submit" className="login-form-button" loading={loading}><FaIcon icon="paper-plane" /> <FormattedMessage id="passwordRecovery.sendMail" /></Button>
                            <div style={{ marginTop: '30px' }}><Link to="/login"><FaIcon fixedWidth icon="arrow-left" /> <FormattedMessage id="message.backToLogin" /></Link></div>
                        </FormItem>
                    </Form>
                </Content>
                <Footer style={{ textAlign: 'center', background: '#f8f8f8' }}>
                    &copy; 2020 - <FormattedMessage id="footer.createdBy" /> <a href="https://www.neoxis.be"><FaIcon icon="code" /> Neoxis</a>
                </Footer>
            </Layout>
        )
    }
    
}

const mapStateToProps = (state, ownProps) => ({
    session: state.session
})

export default injectIntl(withRouter(connect(mapStateToProps, {
    recoverSession
})(Form.create()(PasswordRecovery))))


// WEBPACK FOOTER //
// ./src/containers/PasswordRecovery.js